import { RefObject, useLayoutEffect, useMemo, useState } from 'react'

export interface ElementSize extends Omit<DOMRectReadOnly, 'toJSON'> {}

export const InitialElementSize = (): ElementSize => (
    {
        bottom: 0,
        height: 0,
        left: 0,
        right: 0,
        top: 0,
        width: 0,
        x: 0,
        y: 0,
    }
)

export function useResizeObserver<T extends HTMLElement | SVGElement = HTMLElement | SVGElement> (ref: RefObject<T | null>)
{
    const [sizeState, setSize] = useState<ElementSize>(InitialElementSize())

    useLayoutEffect(() =>
    {
        if (!ref.current) {
            return
        }

        const ro = new ResizeObserver(([entry]) =>
        {
            const target = entry.target
            if (target instanceof SVGGraphicsElement) {
                setSize(target.getBBox())
                return
            }

            setSize(entry.contentRect)
        })
        ro.observe(ref.current)
        return () => ro.disconnect()
    }, [ref])

    return useMemo<ElementSize>(
        () => sizeState,
        [sizeState],
    )
}